/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OrderCountry
 */
export interface OrderCountry {
    /**
     * 
     * @type {boolean}
     * @memberof OrderCountry
     */
    isDefault?: boolean;
    /**
     * 
     * @type {string}
     * @memberof OrderCountry
     */
    remoteId?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderCountry
     */
    code?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderCountry
     */
    name?: string;
}

/**
 * Check if a given object implements the OrderCountry interface.
 */
export function instanceOfOrderCountry(value: object): value is OrderCountry {
    return true;
}

export function OrderCountryFromJSON(json: any): OrderCountry {
    return OrderCountryFromJSONTyped(json, false);
}

export function OrderCountryFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrderCountry {
    if (json == null) {
        return json;
    }
    return {
        
        'isDefault': json['isDefault'] == null ? undefined : json['isDefault'],
        'remoteId': json['remoteId'] == null ? undefined : json['remoteId'],
        'code': json['code'] == null ? undefined : json['code'],
        'name': json['name'] == null ? undefined : json['name'],
    };
}

export function OrderCountryToJSON(json: any): OrderCountry {
    return OrderCountryToJSONTyped(json, false);
}

export function OrderCountryToJSONTyped(value?: OrderCountry | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'isDefault': value['isDefault'],
        'remoteId': value['remoteId'],
        'code': value['code'],
        'name': value['name'],
    };
}

